export default __webpack_public_path__ + "static/media/Carosel P 4.3cda6a2f.svg";